import { SupportPage } from "@-/dev.improve.haniverse.routes.support";

export default function SupportRoute() {
  return <SupportPage />;
}
